import { Locale } from "../constants";

export function getLocaleByUrl(): Locale {
  try {
    if (typeof window === "undefined") throw new Error("Window is undefined");

    const rawUrlLocale = window.location.pathname.split("/")[1];
    return isLocale(rawUrlLocale) ? rawUrlLocale : Locale.ENID;
  } catch (error) {
    const err = error as Error;
    console.error("[ERROR]", err.message, {
      stack: err.stack,
      context: {
        message: err.message,
        currentLocale:
          typeof window === "undefined"
            ? "no locale"
            : window?.location?.pathname?.split("/")[1],
      },
    });
    return Locale.ENID;
  }
}

export function isLocale(str: string): str is Locale {
  return /^[a-z]{2}-[a-z]{2}$/.test(str);
}

export function hasSupportedLocales(path?: string) {
  if (!path) {
    return false;
  }

  return (Object.keys(Locale) as Array<keyof typeof Locale>)
    .map((locale) => Locale[locale])
    .some((locale) => path.includes(locale));
}
